export { default as PropertyView } from './PropertyView'
